import { FiMessageCircle } from "react-icons/fi";

/**
 * TestimonialHighlight
 * Compact testimonial block for portfolio and case study pages.
 */
const TestimonialHighlight = ({
  quote,
  name,
  role,
  company,
  className = "",
}) => {
  return (
    <div className={`relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 md:p-8 ${className}`}>
      <div className="absolute -left-12 -top-12 w-32 h-32 rounded-full bg-[#d6fa70]/40 blur-3xl" aria-hidden />
      <div className="relative space-y-4">
        <p className="text-xl md:text-2xl text-slate-800 leading-relaxed">“{quote}”</p>
        <div className="text-sm text-slate-600">
          <p className="font-semibold text-slate-900">{name}</p>
          <p>{role}{company ? ` · ${company}` : ''}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialHighlight;
